export const WIDGET_DEFAULT_HEIGHT = 6;
export const WIDGET_DEFAULT_WIDTH = 6;
export const WIDGET_DEFAULT_X = 0;
export const WIDGET_DEFAULT_Y = 99999;
export const GRID_ROW_HEIGHT = 50;
